<script setup>

import {storeToRefs} from "pinia";
import {useExerciseStore} from "@/stores/exercise.store";
import {useRoute} from "vue-router/dist/vue-router";

const exercisesStore = useExerciseStore();
const route = useRoute();
if (route.query.type !== undefined) {
  exercisesStore.type = route.query.type;
} else {
  exercisesStore.type = '';
}

exercisesStore.fetchAll();
const {exercises, name, type} = storeToRefs(exercisesStore);

const updateType = (type) => {
  exercisesStore.type = type;
  if (type === '') {
    exercisesStore.name = '';
  }
  exercisesStore.fetchAll();
}

const search = async () => {
  exercisesStore.fetchAll();
}

const toggleUserResource = async(resourceId) => {
  await exercisesStore.toggleUserResource(resourceId);
  await exercisesStore.fetchAll();
}

</script>

<template>
  <van-space direction="vertical" fill>
    <van-search v-model="name" @search="search" @cancel="search" placeholder="Search for your exercises"/>
    <van-grid clickable :column-num="3">
      <van-grid-item icon="filter-o" text="All" :dot="type === ''" @click="updateType('')"/>
      <van-grid-item icon="hot-o" text="Meditation" :dot="type === 'meditation'" @click="updateType('meditation')"/>
      <van-grid-item icon="video-o" text="Video" :dot="type === 'video'" @click="updateType('video')"/>
      <van-grid-item icon="volume-o" text="Audio" :dot="type === 'audio'" @click="updateType('audio')"/>
      <van-grid-item icon="orders-o" text="Reading" :dot="type === 'reading'" @click="updateType('reading')"/>
      <van-grid-item icon="edit" text="Journal" :dot="type === 'journal'" @click="updateType('journal')"/>
    </van-grid>

    <van-card
        :tag="exercise.type"
        v-for="exercise in exercises"
        :key="exercise.id"
        :title="exercise.name"
        :desc="exercise.short_description"
        :thumb="exercise.icon_url"
    >
      <template #tags>
        <van-tag v-if="exercise.user_treatment_session_id" plain round size="medium" type="success" >
          {{ exercise.treatment_session_name }}
        </van-tag>
      </template>
      <template #footer>
        <span v-if="exercise.user_treatment_session_id">
          <van-button  icon="todo-list-o" size="small" :to="'/session/' + exercise.user_treatment_session_id" ></van-button>
        </span>
        <span v-else>
          <van-button icon="star" v-if="exercise.user_exercise_id" size="small" @click="toggleUserResource(exercise.id)"></van-button>
          <van-button icon="star-o" v-else size="small" @click="toggleUserResource(exercise.id)" ></van-button>
        </span>
        <van-button icon="play-circle-o" size="small" :to="'/library/' + exercise.id" ></van-button>
      </template>
    </van-card>

  </van-space>
</template>
